import { render, staticRenderFns } from "./userorder.vue?vue&type=template&id=202a3878&"
import script from "./userorder.vue?vue&type=script&lang=js&"
export * from "./userorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports